<template>
    <kt-row v-if="status === 'setFormData'">
        <kt-col xs="12">
            <form @submit.prevent="edit" id="deposit_settings_form">
                <kt-form-group>
                    <kt-form-label>
                        {{ $t('label.change_status') }}
                    </kt-form-label>
                    <kt-form-select
                        size="3"
                        id="status"
                        name="status"
                        v-model="deposit.status"
                    >
                        <option
                            v-bind:key="index"
                            v-for="(status, index) in depositStatus"
                            v-bind:value="status"
                            :selected="deposit.status === status"
                        >
                            {{ depositStatusStr.get(status) }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
                <div class="container p-3 pt-5 my-4 border in-border-header">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('label.wage_settings') }}
                        </div>
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('label.change_wage_type') }}
                            </kt-form-label>
                            <kt-form-select size="3" id="wage_type" name="wage_type" v-model="deposit.wage_type">
                                <option
                                    v-bind:key="index"
                                    v-for="(wage_type, index) in wage_types"
                                    v-bind:value="wage_type.value"
                                    :selected="wage_type.value"
                                >
                                    {{ wage_type.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>

                        <transition name="fade">
                            <kt-form-group v-if="deposit.wage_type == 1">
                                <kt-form-label>
                                    {{ $t('label.change_wage_period') }}
                                </kt-form-label>
                                <kt-form-select
                                    size="4"
                                    id="wage_periodic_type"
                                    name="wage_periodic_type"
                                    v-model="deposit.wage_periodic_type"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(wage_periodic_type, index) in wage_periodic_types"
                                        v-bind:value="wage_periodic_type.value"
                                        :selected="wage_periodic_type.value"
                                    >
                                        {{ wage_periodic_type.name }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group>
                                <kt-form-label>
                                    {{
                                        (deposit.wage_type == 3) ?
                                            $t('label.wage_amount_percent') :
                                            ((deposit.wage_type == 2) ?
                                                $t('label.wage_amount_fixed') :
                                                $t('label.wage_amount_periodic'))
                                    }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="wage_amount" name="wage_amount"
                                                     v-model="deposit.wage_amount">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 3px">{{
                                    (deposit.wage_type == 3) ?
                                        $t('label.percent') :
                                        $t('currency.rial')
                                }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group v-if="deposit.wage_type == 3">
                                <kt-form-label>
                                    {{ $t('label.min_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="wage_min_wage" name="wage_min_wage"
                                                     v-model="deposit.wage_min_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 2px">{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group v-if="deposit.wage_type == 3">
                                <kt-form-label>
                                    {{ $t('label.max_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="wage_max_wage" name="wage_max_wage"
                                                     v-model="deposit.wage_max_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 2px">{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                    </kt-form-section>
                </div>
                <div class="container p-3 pt-5 my-4 border in-border-header">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('label.internal_wage') }}
                        </div>
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('label.change_wage_type') }}
                            </kt-form-label>
                            <kt-form-select size="3" id="internal_wage_type" name="internal_wage_type" v-model="deposit.internal_wage_type">
                                <option
                                    v-bind:key="index"
                                    v-for="(wage_type, index) in wage_types"
                                    v-bind:value="wage_type.value"
                                    :selected="wage_type.value"
                                >
                                    {{ wage_type.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>

                        <transition name="fade">
                            <kt-form-group v-if="deposit.internal_wage_type == 1">
                                <kt-form-label>
                                    {{ $t('label.change_wage_period') }}
                                </kt-form-label>
                                <kt-form-select
                                    size="4"
                                    id="internal_wage_periodic_type"
                                    name="internal_wage_periodic_type"
                                    v-model="deposit.internal_wage_periodic_type"
                                >
                                    <option
                                        v-bind:key="index"
                                        v-for="(wage_periodic_type, index) in wage_periodic_types"
                                        v-bind:value="wage_periodic_type.value"
                                        :selected="wage_periodic_type.value"
                                    >
                                        {{ wage_periodic_type.name }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group>
                                <kt-form-label>
                                    {{
                                        (deposit.internal_wage_type == 3) ?
                                            $t('label.wage_amount_percent') :
                                            ((deposit.internal_wage_type == 2) ?
                                                $t('label.wage_amount_fixed') :
                                                $t('label.wage_amount_periodic'))
                                    }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="internal_wage_amount" name="internal_wage_amount"
                                                     v-model="deposit.internal_wage_amount">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 3px">{{
                                    (deposit.internal_wage_type == 3) ?
                                        $t('label.percent') :
                                        $t('currency.rial')
                                }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group v-if="deposit.internal_wage_type == 3">
                                <kt-form-label>
                                    {{ $t('label.min_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="internal_wage_min_wage" name="internal_wage_min_wage"
                                                     v-model="deposit.internal_wage_min_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 2px">{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                        <transition name="fade">
                            <kt-form-group v-if="deposit.internal_wage_type == 3">
                                <kt-form-label>
                                    {{ $t('label.max_wage_amount') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--left">
                                    <kt-form-control type="text" dir="ltr" id="internal_wage_max_wage" name="internal_wage_max_wage"
                                                     v-model="deposit.internal_wage_max_wage">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--left">
                            <span style="margin-top: 2px">{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </transition>
                    </kt-form-section>
                </div>
                <kt-form-action class="mt-4">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="deposit_change_status_btn">
                        {{ $t('btn.edit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-col>
    </kt-row>
</template>

<script>
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {depositStatus, depositStatusStr} from '@/constants/deposit'
import {mapGetters} from 'vuex'
import {depositPfService, depositStarshopService} from "@/common/api.service"
import {i18n} from '@/plugins/i18n'

export default {
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        ...mapGetters('deposit', {
            deposit: 'form_data',
            status: 'status',
            accounts: 'accounts',
            accounts_status: 'accounts_status'
        }),
    },
    mounted() {
        this.$store.dispatch('deposit/getAccounts', this.gatewaySource === 'starshop')
        this.runSelectPicker()
    },
    data() {
        return {
            depositStatus,
            depositStatusStr,
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 2
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 1,
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ],
            depositPfService,
            depositStarshopService
        }
    },
    methods: {
        edit(e) {
            let btn = $('#deposit_change_status_btn')
            let form = $('#deposit_settings_form')

            form.validate({
                rules: {
                    status: {
                        required: true
                    },
                    wage_type: {
                        required: true
                    },
                    wage_amount: {
                        required: true,
                    },
                    wage_periodic_type: {
                        required: this.deposit.wage_type == 1
                    },
                    wage_min_wage: {
                        required: this.deposit.wage_type == 3,
                    },
                    wage_max_wage :{
                        required:this.deposit.wage_type == 3,
                    },
                    internal_wage_type: {
                        required: true
                    },
                    internal_wage_amount: {
                        required: true,
                    },
                    internal_wage_periodic_type: {
                        required: this.deposit.internal_wage_type == 1
                    },
                    internal_wage_min_wage: {
                        required: this.deposit.internal_wage_type == 3,
                    },
                    internal_wage_max_wage: {
                        required: this.deposit.internal_wage_type == 3,
                    },
                }
            });

            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)

            let is_failed = false
            this.apiService.adminChangeStatus(this.deposit.id, this.deposit.status)
                .then(this.$store.dispatch('badgeCounter/countData'))
                .catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    is_failed = true
                })

            this.apiService.adminChangeWage(this.deposit.id, {
                wage_type: this.deposit.wage_type,
                wage_periodic_type: this.deposit.wage_periodic_type,
                wage_amount: this.deposit.wage_amount,
                wage_min_wage: Number(this.deposit.wage_min_wage),
                wage_max_wage: this.deposit.wage_max_wage,
                internal_wage_type: this.deposit.internal_wage_type,
                internal_wage_periodic_type: this.deposit.internal_wage_periodic_type,
                internal_wage_amount: this.deposit.internal_wage_amount,
                internal_wage_min_wage: Number(this.deposit.internal_wage_min_wage),
                internal_wage_max_wage: this.deposit.internal_wage_max_wage,
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                is_failed = true
            }).finally(response => {
                KTApp.unprogress(btn)
                if (is_failed) {
                    this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
                } else {
                    this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
                }
            })
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>